import React, {useContext, useEffect, useState} from "react";
import FiltersBar from "./FiltersBar";
import SortDrawer from "./SortDrawer";
import OfferList from "./OfferList";
import MetaTagsManipulator from "../../utils/MetaTagsManipulator";
import UrlDecorator from "../../utils/UrlDecorator";
import URLSearchParamsConverter from "../../utils/URLSearchParamsConverter";
import {useLocation, withRouter} from "react-router";
import {goVehisService} from "../../utils/axios";
import {CustomerTypeContext} from "../../context/customer-type-context";
import ExpertHelp from "../HomePage/ExpertHelp";
import HomeNewsletter from "../HomePage/HomeNewsletter";

function OfferListPage(props) {

    MetaTagsManipulator.setTitle("Lista ofert");
    MetaTagsManipulator.setDescription("Lista ofert");

    UrlDecorator.addSellerCode();

    const [isSortDrawerOpen, setIsSortDrawerOpen] = useState(false);
    const [offerViewType, setOfferViewType] = useState("grid-view");
    const [offersNumber, setOffersNumber] = useState("...");

    const customerContextType = useContext(CustomerTypeContext)[0];

    const initialState = {
        brands: [],
        models: [],
        bodyTypes: [],
        fuelTypes: [],
        segments: [],
        installmentNetFrom: "",
        installmentNetTo: "",
        installmentGrossFrom: "",
        installmentGrossTo: "",
        minimumSellPriceNetFrom: "",
        minimumSellPriceNetTo: "",
        minimumSellPriceGrossFrom: "",
        minimumSellPriceGrossTo: "",
        mileageFrom: "",
        mileageTo: "",
        manufactureYearFrom: "",
        manufactureYearTo: "",
        enginePowerHpFrom: "",
        enginePowerHpTo: "",
        engineCapacityFrom: "",
        engineCapacityTo: "",
        gearboxTypes: [],
        driveTypes: [],
        colors: [],
        numberOfDoors: [],
        numberOfSeats: [],
        equipment: [],
        availability: false,
        specialOffer: false,
        isPremium: false,
        vehicleTypes: "OSOBOWE",
        newUsed: "all",
        calculationTypes: [],
        nip: "",
        createdFrom: "",
        createdTo: "",
        sources: []
    };

    const [searchParameters, setSearchParameters] = useState(initialState);

    const location = useLocation();

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(props.location.search);
        urlSearchParams.set("limit", "1000000");
        urlSearchParams.set("customerType", customerContextType);
        urlSearchParams.delete("page");

        goVehisService.get("/vehicles/count?" + urlSearchParams).then(response => {
            setOffersNumber(parseInt(response.data, 10) || 0);
        });
    }, [props.location.search, customerContextType]);

    return (
        <div className="lista-ofert">

            <SortDrawer
                isOpen={isSortDrawerOpen}
                title="Wybierz sortowanie"
                onClose={() => setIsSortDrawerOpen(false)}/>

            <FiltersBar
                offersNumber={offersNumber}
                viewType={offerViewType}
                onViewTypeChange={(viewType) => setOfferViewType(viewType)}
                sortClicked={() => setIsSortDrawerOpen(true)}
                setSearchParameters={(params) => setSearchParameters(params)}
                searchParameters={searchParameters}
                initialState={initialState}/>

            <OfferList
                viewType={offerViewType}
                offersNumber={offersNumber}
                setSearchParameters={(params) => setSearchParameters(params)}
                searchParameters={searchParameters}/>

            <ExpertHelp/>
            <HomeNewsletter/>

        </div>
    );
}

export default withRouter(OfferListPage);
